import { useMutation } from "@tanstack/react-query";
import useToastes from "shared/hooks/useToastes";
import { typedMutation } from "../types/typedQueries";
import { fileDataInstance, formDataApi, instance } from "./common";
import { OneFileT, SendFileT } from "../types/files";

const BASE_URL = "files";

const convertFilesToFormData = (files: FileList | File[]): FormData => {
  const formData = new FormData();

  Array.from(files).forEach((file, index) => {
    formData.append(`file[${String(index)}]`, file);
  });

  return formData;
};

export const useGetOneFile = typedMutation<OneFileT>(() =>
  useMutation({
    mutationFn: async ({ fileId }) =>
      await fileDataInstance.get(`${BASE_URL}/${fileId}`, {
        responseType: "blob",
      }),
  }),
);

export const useDeleteFile = typedMutation<OneFileT>(() => {
  const { successToast } = useToastes();


  return useMutation({
    mutationFn: async ({ fileId }) =>
      await instance.delete(`${BASE_URL}/${fileId}`),
    onSuccess: () => {
      successToast("Files was successfully deleted");
    },
  });
});

export const useSendFiles = typedMutation<SendFileT>(
  ({ pathParams: { sourceId } }) => {
    const { successToast } = useToastes();

    return useMutation({
      mutationFn: (data) => {
        const formData = convertFilesToFormData(data);
        return formDataApi.post(`${BASE_URL}/${sourceId}`, formData);
      },
      onSuccess: () => {
        successToast("Files was successfully uploaded");
      },
    });
  },
);
